// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__ayaZf","footer":"ModalCreateQualiphyProcedure_footer__1rUDe","additionData":"ModalCreateQualiphyProcedure_additionData__1V0Ne"};